module.exports = __webpack_public_path__ + "static/media/n00121.752b3d54.jpg";